import { render, staticRenderFns } from "./CreateTaxDialog.vue?vue&type=template&id=810a8272&scoped=true"
import script from "./CreateTaxDialog.vue?vue&type=script&lang=js"
export * from "./CreateTaxDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "810a8272",
  null
  
)

export default component.exports